import { ISSUE_COUNT } from '../../../../model/constants';
import {
	LOAD_CONFIG_DATA_MODEL_SUCCESS,
	SET_APP_DATA,
	SET_CONFIG_DATA,
} from '../../../actions/app';
import type { Action } from '../../../types';
import type { EstimationEntityState } from './types';

const defaultState: EstimationEntityState = {
	isEstimationFeatureEnabled: false,
	estimationType: ISSUE_COUNT,
	estimationFieldId: null,
	name: '',
};

export default function estimationReducer(
	state: EstimationEntityState = defaultState,
	action: Action,
): EstimationEntityState {
	if (
		action.type === SET_APP_DATA ||
		action.type === SET_CONFIG_DATA ||
		action.type === LOAD_CONFIG_DATA_MODEL_SUCCESS
	) {
		if (!action.payload.entities.estimation) {
			return state;
		}

		const { isEstimationFeatureEnabled, estimationType, estimationFieldId, name } =
			action.payload.entities.estimation || {};

		return {
			isEstimationFeatureEnabled: isEstimationFeatureEnabled || false,
			estimationType: estimationType || ISSUE_COUNT,
			estimationFieldId: estimationFieldId || null,
			name: name || '',
		};
	}

	return state;
}
